import { jsx as _jsx } from "react/jsx-runtime";
import { Form } from "antd";
import { useRef, useState } from "react";
import { QuillEditorWrapper } from "./quill-editor-wrapper.js";
import { QuillSimpleHtmlContent } from "./quill-simple-html-content.js";
import { useOutsideClick } from "../../hooks/useOutsideClick.js";
const QuillEditorFormField = ({ namePath, formProps, quillEditorProps })=>{
    const [showComponent, setShowComponent] = useState(false);
    const handleEnter = ()=>{
        if (quillEditorProps?.readOnly !== true) {
            setShowComponent(true);
        }
    };
    const handleLeave = ()=>{
        setShowComponent(false);
    };
    const wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, ()=>{
        handleLeave(); // clicked outside!
    });
    return showComponent ? /*#__PURE__*/ _jsx("div", {
        ref: wrapperRef,
        children: /*#__PURE__*/ _jsx(Form.Item, {
            name: namePath,
            noStyle: true,
            ...formProps,
            children: /*#__PURE__*/ _jsx(QuillEditorWrapper, {
                ...quillEditorProps
            })
        })
    }) : // value of QuillSimpleHtmlContent is filled automatically as it is child of an Form.Item
    /*#__PURE__*/ _jsx("div", {
        onClick: handleEnter,
        children: /*#__PURE__*/ _jsx(Form.Item, {
            name: namePath,
            noStyle: true,
            ...formProps,
            children: /*#__PURE__*/ _jsx(QuillSimpleHtmlContent, {
                readOnly: quillEditorProps?.readOnly,
                style: quillEditorProps?.style
            })
        })
    });
};
export { QuillEditorFormField };
